module.exports = __webpack_public_path__ + "static/grove-amz51e-4c4a95d9f37597ff7d1c3d3b11bbccbe.jpg";